@if (showTable()) {
  <table mat-table [dataSource]="tableDataSource">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ "components.all-leads-list.table.name" | translate }}
      </th>
      <td mat-cell *matCellDef="let lead" tabindex="-1">
        {{ lead.name }}
      </td>
    </ng-container>
    <!-- combined column to display postalCode and city on tiny displays -->
    <ng-container matColumnDef="postalCodeCity">
      <th mat-header-cell *matHeaderCellDef>
        {{ "components.all-leads-list.table.postalCode" | translate }} /
        {{ "components.all-leads-list.table.city" | translate }}
      </th>
      <td mat-cell *matCellDef="let lead" tabindex="-1">
        <div style="display: block">{{ lead.address.postalCode }}</div>
        <div style="display: block">{{ lead.address.city }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="postalCode">
      <th mat-header-cell *matHeaderCellDef>
        {{ "components.all-leads-list.table.postalCode" | translate }}
      </th>
      <td mat-cell *matCellDef="let lead" tabindex="-1">
        {{ lead.address.postalCode }}
      </td>
    </ng-container>
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef>
        {{ "components.all-leads-list.table.city" | translate }}
      </th>
      <td mat-cell *matCellDef="let lead" tabindex="-1">
        {{ lead.address.city }}
      </td>
    </ng-container>
    <ng-container matColumnDef="remove">
      <th mat-header-cell *matHeaderCellDef>
        <button
          mat-icon-button
          (click)="removeAll()"
          [attr.aria-label]="
            'components.selected-leads-preview.remove-all-confirm' | translate
          "
        >
          <mat-icon>delete</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">
        <button
          mat-icon-button
          (click)="removeSelected(row)"
          [attr.aria-label]="'Deselect ' + row.name"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
} @else {
  {{ "components.selected-leads-preview.no-leads-selected" | translate }}
}
